import { RefreshCw, Loader2 } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { usePartnerFieldMap } from "../use-partner-field-map";
import { useRefreshPartnerFieldMapSchema } from "../use-partner-field-map-mutations";
import { PartnerFieldMappingTable } from "./partner-field-mapping-table";
import { AddPartnerFieldDialog } from "./add-partner-field-dialog";

export function PartnerFieldMappingCard() {
  const query = usePartnerFieldMap();
  const refresh = useRefreshPartnerFieldMapSchema();
  const rows = query.data ?? [];
  const staleCount = rows.filter((r) => r.is_stale).length;

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle className="font-display tracking-tight">
            Partner field mapping
          </CardTitle>
          <CardDescription>
            Pick HubSpot partner properties to surface on the admin partner
            detail page. The 8 core fields are env-mapped and shown read-only.
          </CardDescription>
        </div>
        <div className="flex items-center gap-2">
          <AddPartnerFieldDialog />
          <Button
            size="sm"
            variant="outline"
            onClick={() => refresh.mutate()}
            disabled={refresh.isPending}
            className="gap-1.5"
          >
            {refresh.isPending ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <RefreshCw className="h-3.5 w-3.5" />
            )}
            Refresh schema
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {query.isLoading ? (
          <Skeleton className="h-40 w-full" />
        ) : (
          <PartnerFieldMappingTable rows={rows} />
        )}
        {staleCount > 0 && (
          <p className="mt-3 rounded-md border border-amber-500/40 bg-amber-50/40 px-3 py-2 text-xs text-amber-700 dark:bg-amber-950/20 dark:text-amber-300">
            {staleCount} mapped propert{staleCount === 1 ? "y is" : "ies are"} no
            longer in HubSpot. Remove {staleCount === 1 ? "it" : "them"} or
            re-create in HubSpot under the same internal name.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
